(function(){
    'use strict';

    angular
        .module('elogbooks.common.terms-of-use')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {

        $stateProvider
            .state('dashboard.terms-of-use', {
                url: "/terms-of-use",
                templateUrl: '/modules/common/terms-of-use/terms-of-use.html',
                controller: 'TermsOfUseController',
                controllerAs: 'vm',
                ncyBreadcrumb: {
                    skip: true
                }
            });

    }
})();
